import SvgColor from '../../../components/svg-color';
import Iconify from '../../../components/iconify/Iconify.js';
import { useEffect, useState } from 'react';
import { de } from 'date-fns/locale';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const useNavConfig = () => {
  const [navConfig, setNavConfig] = useState([]);

  const updateNavConfig = () => {
    const role = sessionStorage.getItem("role");
    const serviceTeamType = sessionStorage.getItem("serviceTeamType");
    const roleType = sessionStorage.getItem("roleType");
    console.log("role", role);
    console.log("SERVICETEMA", serviceTeamType); //employee like that
    console.log("Type of serviceTeamType:", typeof serviceTeamType);
    console.log("roleType", roleType); //camera man like that

    if (role === "Admin") {
      setNavConfig([
        {
          title: 'Dashboard',
          path: '/admin/dashboard/app',
          icon: <Iconify icon="material-symbols:dashboard" />,
        },
        {
          title: 'Users',
          path: '/admin/dashboard/users',
          icon: <Iconify icon="mdi:account-group" />,
        },
        {
          title: 'Projects',
          path: '/admin/dashboard/projects',
          icon: <Iconify icon="si:projects-duotone" />,
        },
        {
          title: 'Leads',
          path: '/admin/dashboard/leads',
          icon: <Iconify icon="mdi:leads" />,
        },
        {
          title: 'Sales',
          path: '/admin/dashboard/sales-dashboard',
          icon: <Iconify icon="mdi:trending-up" />,
          children: [
            {
              title: "Under-Follow-Up",
              path: '/admin/dashboard/under-follow-ups',
              icon: <Iconify icon="mdi:progress-clock" />
            },
            {
              title: "Appointments",
              path: '/admin/dashboard/scheduled-appointments',
              icon: <Iconify icon="mdi:calendar-check" />
            },
            {
              title: "Converted Lead",
              path: "/admin/dashboard/converted-leads",
              icon: <Iconify icon="mdi:account-convert" />
            },
          ],
        },
        {
          title: 'Service',
          icon: <Iconify icon="eos-icons:service" />,
          children: [
            {
              title: "CC Team",
              path: "/admin/dashboard/content-creation-team",
              icon: <Iconify icon="mdi:pen" />,
            },
            {
              title: "Camera Team",
              path: "/admin/dashboard/camera-team",
              icon: <Iconify icon="solar:camera-bold" />
            },
            {
              title: "Editing Team",
              path: "/admin/dashboard/editing-team",
              icon: <Iconify icon="mdi:pencil-box-outline" />
            },
            {
              title: "SEO Team",
              path: "/admin/dashboard/seo-team",
              icon: <Iconify icon="mdi:chart-line" />,
            },
            {
              title: "Website Team",
              path: "/admin/dashboard/website-team",
              icon: <Iconify icon="mdi:developer-board" />,
            },
            {
              title: "Graphic Design",
              path: "/admin/dashboard/graphic-design-team",
              icon: <Iconify icon="mdi:palette" />,
            },
            {
              title: "Social Media",
              path: "/admin/dashboard/social-media-handler-team",
              icon: <Iconify icon="mdi:web" />,
            },
          ]
        },
      ]);
    } else if (role === "Sales" && roleType === 'Team Leader') {
      setNavConfig([
        {
          title: 'Dashboard',
          path: '/sales/dashboard/app',
          icon: <Iconify icon="material-symbols:dashboard" />,
        },
        {
          title: 'Leads',
          path: '/sales/dashboard/leads',
          icon: <Iconify icon="mdi:leads" />,
        },
        {
          title: 'Sales Dashboard',
          path: '/sales/dashboard/sales-dashboard',
          icon: <Iconify icon="mdi:trending-up" />,
          children: [
            {
              title: "Self Assigned",
              path: "/sales/dashboard/self-assigned-leads",
              icon: <Iconify icon="eos-icons:service" />
            },
            {
              title: "Under-Follow-Up",
              path: '/sales/dashboard/under-follow-ups',
              icon: <Iconify icon="mdi:progress-clock" />
            },
            {
              title: "Appointments",
              path: '/sales/dashboard/scheduled-appointments',
              icon: <Iconify icon="mdi:calendar-check" />
            },
            {
              title: "Converted Lead",
              path: "/sales/dashboard/converted-leads",
              icon: <Iconify icon="mdi:account-convert" />
            }
          ]
        },
      ]);
    } else if (role === "Sales" && roleType === 'Team Leader') {
      setNavConfig([
        {
          title: 'Dashboard',
          path: '/sales/dashboard/app',
          icon: <Iconify icon="material-symbols:dashboard" />,
        },
        {
          title: 'Leads',
          path: '/sales/dashboard/leads',
          icon: <Iconify icon="mdi:leads" />,
        },
        {
          title: 'Sales Dashboard',
          path: '/sales/dashboard/sales-dashboard',
          icon: <Iconify icon="mdi:trending-up" />,
          children: [
            {
              title: "Self Assigned",
              path: "/sales/dashboard/self-assigned-leads",
              icon: <Iconify icon="eos-icons:service" />
            },
            {
              title: "Under-Follow-Up",
              path: '/sales/dashboard/under-follow-ups',
              icon: <Iconify icon="mdi:progress-clock" />
            },
            {
              title: "Appointments",
              path: '/sales/dashboard/scheduled-appointments',
              icon: <Iconify icon="mdi:calendar-check" />
            },
            {
              title: "Converted Lead",
              path: "/sales/dashboard/converted-leads",
              icon: <Iconify icon="mdi:account-convert" />
            }
          ]
        },
      ]);
    } else if (role === "Sales" && roleType === 'Employee') {
      setNavConfig([
        {
          title: 'Dashboard',
          path: '/sales/dashboard/app',
          icon: <Iconify icon="material-symbols:dashboard" />,
        },
        {
          title: 'Sales Dashboard',
          path: '/sales/dashboard/sales-dashboard',
          icon: <Iconify icon="mdi:trending-up" />,
        },
        {
          title: "Under-Follow-Up",
          path: '/sales/dashboard/under-follow-ups',
          icon: <Iconify icon="mdi:progress-clock" />
        },
        {
          title: "Appointments",
          path: '/sales/dashboard/scheduled-appointments',
          icon: <Iconify icon="mdi:calendar-check" />
        },
      ]);
    } else if (role === "Service") {
      const baseServiceItems = [
        {
          title: 'Dashboard',
          path: '/service/dashboard/app',
          icon: <Iconify icon="material-symbols:dashboard" />,
        },
        {
          title: 'Service Dashboard',
          // path: '/service/dashboard/service-dashboard',
          icon: <Iconify icon="eos-icons:service" />,
        }
      ];

      const teamSpecificItems = getTeamSpecificItem(serviceTeamType, roleType);
      if (Array.isArray(teamSpecificItems) && teamSpecificItems.length > 0) {
        baseServiceItems[1].children = teamSpecificItems;
      }

      setNavConfig(baseServiceItems);
    }
    else if (role === "Sales") {
      setNavConfig([
        {
          title: 'Dashboard',
          path: '/sales/dashboard/app',
          icon: <Iconify icon="material-symbols:dashboard" />,
        },
        // {
        //   title: 'Leads',
        //   path: '/sales/dashboard/leads',
        //   icon: <Iconify icon="mdi:leads" />,
        // },
        {
          title: 'Sales Dashboard',
          path: '/sales/dashboard/sales-dashboard',
          icon: <Iconify icon="mdi:trending-up" />,
          children: [
            {
              title: "Converted Lead",
              path: "/sales/dashboard/converted-leads",
              icon: <Iconify icon="mdi:account-convert" />
            }
          ]
        },
      ]);
    }
  };

  const getTeamSpecificItem = (teamType, roleType) => {
    if (!teamType) return [];
    let teamItems = [];

    // Add On-Going Tasks first
    // if (roleType !== "Team Leader") {
    //   const roleTypeEmployee = sessionStorage.getItem("serviceTeamType");
    //   teamItems.push({
    //     title: "Over-all Tasks",
    //     path: `/service/dashboard/${roleTypeEmployee?.toLowerCase().replace(/\s+/g, "-") || "default"}/overall-tasks`,
    //     icon: <Iconify icon="mdi:progress-clock" />
    //   });
    // }

    // Then add Over-all Tasks based on teamType
    switch (teamType?.toLowerCase()) {
      case 'seo':
        teamItems.push({
          title: "SEO Team",
          path: "/service/dashboard/seo-team",
          icon: <Iconify icon="mdi:chart-line" />,
        });
        (roleType === "Team Leader" && (
          teamItems.push({
            title: "self assigned",
            path: "/service/dashboard/seo-self-assigned",
            icon: <Iconify icon="eos-icons:service" />,
          })
        ))
        break;
      case 'content creation':
        teamItems.push({
          title: "On-going Tasks",
          path: "/service/dashboard/content-creation-team",
          icon: <Iconify icon="mdi:pen" />,
        });
        (roleType === "Team Leader" && (
          teamItems.push({
            title: "self assigned",
            path: "/service/dashboard/content-creation-self-assigned",
            icon: <Iconify icon="eos-icons:service" />,
          })
        ))
        break;
      case 'website designing':
        teamItems.push({
          title: "On-going Tasks",
          path: "/service/dashboard/website-team",
          icon: <Iconify icon="mdi:developer-board" />,
        });
        (roleType === "Team Leader" && (
          teamItems.push({
            title: "self assigned",
            path: "/service/dashboard/website-self-assigned",
            icon: <Iconify icon="eos-icons:service" />,
          })
        ))
        break;
      case 'camera man':
        teamItems.push({
          title: "On-going Tasks",
          path: "/service/dashboard/camera-team",
          icon: <Iconify icon="solar:camera-bold" />
        });
        (roleType === "Team Leader" && (
          teamItems.push({
            title: "self assigned",
            path: "/service/dashboard/camera-self-assigned",
            icon: <Iconify icon="eos-icons:service" />,
          })
        ))
        break;
      case 'video editing':
        teamItems.push({
          title: "On-going Tasks",
          path: "/service/dashboard/editing-team",
          icon: <Iconify icon="mdi:pencil-box-outline" />
        });
        (roleType === "Team Leader" && (
          teamItems.push({
            title: "self assigned",
            path: "/service/dashboard/video-editing-self-assigned",
            icon: <Iconify icon="eos-icons:service" />,
          })
        ))
        break;
      case 'graphic designing':
        teamItems.push({
          title: "On-going Tasks",
          path: "/service/dashboard/graphic-design-team",
          icon: <Iconify icon="mdi:palette" />,
        });
        (roleType === "Team Leader" && (
          teamItems.push({
            title: "self assigned",
            path: "/service/dashboard/graphic-self-assigned",
            icon: <Iconify icon="eos-icons:service" />,
          })
        ))
        break;
      case 'social media':
        teamItems.push({
          title: "On-going Tasks",
          path: '/service/dashboard/social-media-handler-team',
          icon: <Iconify icon="mdi:palette" />
        });
        (roleType === "Team Leader" && (
          teamItems.push({
            title: "self assigned",
            path: "/service/dashboard/social-media-self-assigned",
            icon: <Iconify icon="eos-icons:service" />,
          })
        ))
        break;
      default:
        teamItems = [];
    }

    return teamItems.length ? teamItems : null;
  };


  useEffect(() => {
    updateNavConfig();

    const handleStorageChange = () => {
      updateNavConfig();
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return navConfig;
};

export default useNavConfig;